import { ZoomTransformation } from '../../../common/zoom/models/zoom-model';
import { CirclePacking } from '../../models/circlePackingModel';
import { MAIN_DEPTH } from '../constants';
import { circleRender } from '../render/circleRender';

/**
 *
 * @param circlesPacking Hierarchical data
 * @param context Canvas context
 * @param zoom zoom transformation
 * @param renderDepth how many levels to render
 */
export const circleRenderRecursive: (
  circlesPacking: Array<CirclePacking>,
  context: CanvasRenderingContext2D,
  zoom: ZoomTransformation,
  renderDepth?: number
) => void = (circlesPacking, context, zoom, renderDepth) => {
  (circlesPacking || []).forEach((node, i) => {
    // Render Circles
    circleRender(node, context, zoom, node.depth === MAIN_DEPTH);

    if (node.children) {
      // if renderDepth is specified, we do recursive until we reach the depth
      if (renderDepth && node.depth < renderDepth) {
        circleRenderRecursive(node.children, context, zoom, renderDepth);
        return;
      } else if (!renderDepth) {
        circleRenderRecursive(node.children, context, zoom, renderDepth);
      }
    }
  });
};
